export const CLAUDE_CODE_CONVERSATION_EVENT = 'claude-code-conversation-event'
export const STATUS_SESSION_CHANGED_EVENT = 'status-session-changed'
export const STATUS_HOST_CHANGED_EVENT = 'status-host-changed'
export const TRANSIENT_SESSION_EVENT_TYPE = 'TRANSIENT_SESSION_EVENT'
